import axios from 'axios';

// Environment-based API URL configuration
const getApiBaseUrl = () => {
  // For production deployment, you might want to use HTTPS
  if (window.location.hostname.includes('s3-website') || window.location.hostname.includes('amazonaws.com')) {
    // Production on AWS S3 - use HTTPS if available
    return 'https://api.geniusdock.com/api';
  }      
  
  // Local development
  if (window.location.hostname === 'localhost') {
    //return 'http://3.87.61.185/api';
    return 'http://192.168.1.73:8088/api';
   //return 'https://api.geniusdock.com/api';
  }
  
  // Default
  return 'https://api.geniusdock.com/api';
};

const API_BASE_URL = getApiBaseUrl();

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add a request interceptor for adding the auth token
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('adminToken');
    
    // If token exists, add it to the headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Authentication
export const login = async (credentials) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/admin/auth/login`, credentials);
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/admin/auth/forgot-password`, {
      email
    });
    return response.data;
  } catch (error) {
    console.error('Forgot password error:', error);
    throw error;
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/admin/auth/reset-password`, {
      token,
      newPassword
    });
    return response.data;
  } catch (error) {
    console.error('Reset password error:', error);
    throw error;
  }
};

// Users
export const fetchUsers = async (params) => {
  try {
    const response = await api.get('/admin/users', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const updateUserStatus = async (userId, isActive) => {
  try {
    const response = await api.put('/admin/users/status', {
      userId,
      isActive
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user status:', error);
    throw error;
  }
};

// Companies
export const fetchCompanies = async (params) => {
  try {
    const response = await api.get('/api/companies', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching companies:', error);
    throw error;
  }
};

export const updateCompany = async (companyId, companyData) => {
  try {
    const fullUrl = `${API_BASE_URL}/api/companies/${companyId}`;
    
    console.log('=== UPDATE COMPANY API CALL ===');
    console.log('Company ID:', companyId);
    console.log('Full URL:', fullUrl);
    console.log('Payload:', JSON.stringify(companyData, null, 2));
    console.log('Base URL:', API_BASE_URL);
    console.log('Relative URL:', `/api/companies/${companyId}`);
    console.log('Headers:', {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('adminToken')}`
    });
    
    const response = await api.put(`/api/companies/${companyId}`, companyData);
    
    console.log('=== UPDATE COMPANY API RESPONSE ===');
    console.log('Status:', response.status);
    console.log('Response Data:', JSON.stringify(response.data, null, 2));
    console.log('===================================');
    
    return response.data;
  } catch (error) {
    console.error('=== UPDATE COMPANY API ERROR ===');
    console.error('Error details:', error);
    console.error('Error response:', error.response?.data);
    console.error('Error status:', error.response?.status);
    console.error('Error headers:', error.response?.headers);
    console.error('================================');
    throw error;
  }
};

export const updateCompanyPassword = async (companyId, password) => {
  try {
    const fullUrl = `${API_BASE_URL}/api/companies/${companyId}/password`;
    const payload = { password };
    
    console.log('=== UPDATE COMPANY PASSWORD API CALL ===');
    console.log('Company ID:', companyId);
    console.log('Full URL:', fullUrl);
    console.log('Payload:', JSON.stringify(payload, null, 2));
    console.log('Base URL:', API_BASE_URL);
    console.log('Relative URL:', `/api/companies/${companyId}/password`);
    console.log('Headers:', {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('adminToken')}`
    });
    
    const response = await api.patch(`/api/companies/${companyId}/password`, payload);
    
    console.log('=== UPDATE COMPANY PASSWORD API RESPONSE ===');
    console.log('Status:', response.status);
    console.log('Response Data:', JSON.stringify(response.data, null, 2));
    console.log('==========================================');
    
    return response.data;
  } catch (error) {
    console.error('=== UPDATE COMPANY PASSWORD API ERROR ===');
    console.error('Error details:', error);
    console.error('Error response:', error.response?.data);
    console.error('Error status:', error.response?.status);
    console.error('Error headers:', error.response?.headers);
    console.error('=========================================');
    throw error;
  }
};

// Contests
export const fetchContests = async (params) => {
  try {
    const response = await api.get('/api/contests', { params });
    // Ensure we have all pagination information
    return {
      content: response.data.content || [],
      totalPages: response.data.totalPages || 0,
      totalElements: response.data.totalElements || 0,
      page: response.data.pageable?.pageNumber || 0,
      size: response.data.pageable?.pageSize || 10
    };
  } catch (error) {
    console.error('Error fetching contests:', error);
    throw error;
  }
};

export const fetchCompanyContests = async (params) => {
  try {
    const response = await api.get('/api/contests', { params });
    return {
      content: response.data.content || [],
      totalPages: response.data.totalPages || 0,
      totalElements: response.data.totalElements || 0,
      page: response.data.pageable?.pageNumber || 0,
      size: response.data.pageable?.pageSize || 10
    };
  } catch (error) {
    console.error('Error fetching company contests:', error);
    throw error;
  }
};

export const createContest = async (contestData) => {
  try {
    const response = await api.post('/api/contests', contestData);
    return response.data;
  } catch (error) {
    console.error('Error creating contest:', error);
    throw error;
  }
};

export const updateContest = async (contestId, contestData) => {
  try {
    const response = await api.put(`/api/contests/${contestId}`, contestData);
    return response.data;
  } catch (error) {
    console.error('Error updating contest:', error);
    throw error;
  }
};

// Categories and Subcategories
export const fetchCategories = async () => {
  try {
    const response = await api.get('/api/categories');
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export const fetchSubcategories = async (categoryId) => {
  try {
    const response = await api.get(`/api/subcategories${categoryId ? `?categoryId=${categoryId}` : ''}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching subcategories:', error);
    throw error;
  }
};

// Subcategories
export const fetchAllSubcategories = async (params) => {
  try {
    const cleanedParams = cleanParams(params);
    console.log('=== FETCH SUBCATEGORIES API CALL ===');
    console.log('Original params:', params);
    console.log('Cleaned params:', cleanedParams);
    
    const response = await api.get('/api/subcategories', { params: cleanedParams });
    
    console.log('=== FETCH SUBCATEGORIES API RESPONSE ===');
    console.log('Status:', response.status);
    console.log('Response Data:', response.data);
    console.log('==========================================');
    
    return response.data;
  } catch (error) {
    console.error('=== FETCH SUBCATEGORIES API ERROR ===');
    console.error('Error details:', error);
    console.error('Error response:', error.response?.data);
    console.error('Error status:', error.response?.status);
    console.error('=====================================');
    throw error;
  }
};

export const createSubcategory = async (subcategoryData) => {
  try {
    const response = await api.post('/api/subcategories', subcategoryData);
    return response.data;
  } catch (error) {
    console.error('Error creating subcategory:', error);
    throw error;
  }
};

export const createBulkSubcategories = async (bulkData) => {
  try {
    const response = await api.post('/api/subcategories/bulk', bulkData);
    return response.data;
  } catch (error) {
    console.error('Error creating bulk subcategories:', error);
    throw error;
  }
};

export const updateSubcategory = async (subcategoryId, subcategoryData) => {
  try {
    const response = await api.put(`/api/subcategories/${subcategoryId}`, subcategoryData);
    return response.data;
  } catch (error) {
    console.error('Error updating subcategory:', error);
    throw error;
  }
};

export const deleteSubcategory = async (subcategoryId) => {
  try {
    const response = await api.delete(`/api/subcategories/${subcategoryId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting subcategory:', error);
    throw error;
  }
};

// Participants
export const fetchParticipants = async (params) => {
  try {
    const response = await api.get('/api/contests/user-submissions', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching participants:', error);
    throw error;
  }
};



// Admin
export const updateAdminPassword = async (passwordData) => {
  try {
    const response = await api.put('/admin/auth/update-password', passwordData);
    return response.data;
  } catch (error) {
    console.error('Error updating password:', error);
    throw error;
  }
};

// Jobs
export const fetchJobs = async (params) => {
  try {
    const response = await api.get('/api/sponsor/jobs', { params });
    // Ensure we have all pagination information
    return {
      content: response.data.content || [],
      totalPages: response.data.totalPages || 0,
      totalElements: response.data.totalElements || 0,
      page: response.data.page || 0,
      size: response.data.size || 10
    };
  } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error;
  }
};

export const createJob = async (jobData) => {
  try {
    const response = await api.post('/api/sponsor/jobs', jobData);
    return response.data;
  } catch (error) {
    console.error('Error creating job:', error);
    throw error;
  }
};

export const updateJob = async (jobId, jobData) => {
  try {
    const response = await api.put(`/api/sponsor/jobs/${jobId}`, jobData);
    return response.data;
  } catch (error) {
    console.error('Error updating job:', error);
    throw error;
  }
};

export const deleteJob = async (jobId) => {
  try {
    const response = await api.delete(`/api/sponsor/jobs/${jobId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting job:', error);
    throw error;
  }
};

// Job Applicants
export const fetchJobApplicants = async (jobId, params) => {
  try {
    const response = await api.get(`/api/sponsor/jobs/${jobId}/applicants`, { params });
    return {
      content: response.data.content || [],
      totalPages: response.data.totalPages || 0,
      totalElements: response.data.totalElements || 0,
      page: response.data.page || 0,
      size: response.data.size || 10,
      last: response.data.last || false
    };
  } catch (error) {
    console.error('Error fetching job applicants:', error);
    throw error;
  }
};

export const updateApplicationStatus = async (applicationId, status, notes = '') => {
  try {
    const response = await api.put(`/api/sponsor/jobs/applications/${applicationId}/status`, {
      status,
      notes
    });
    return response.data;
  } catch (error) {
    console.error('Error updating application status:', error);
    throw error;
  }
};

// Middle Categories
export const fetchMiddleCategories = async (categoryName = 'Arts') => {
  try {
    const response = await api.get(`/api/middle-categories/category/name/${categoryName}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching middle categories:', error);
    throw error;
  }
};

export const fetchAllMiddleCategories = async (params) => {
  try {
    const cleanedParams = cleanParams(params);
    const response = await api.get('/api/middle-categories', { params: cleanedParams });
    return response.data;
  } catch (error) {
    console.error('Error fetching all middle categories:', error);
    throw error;
  }
};

export const createMiddleCategory = async (middleCategoryData) => {
  try {
    const response = await api.post('/api/middle-categories', middleCategoryData);
    return response.data;
  } catch (error) {
    console.error('Error creating middle category:', error);
    throw error;
  }
};

export const createBulkMiddleCategories = async (bulkData) => {
  try {
    const response = await api.post('/api/middle-categories/bulk', bulkData);
    return response.data;
  } catch (error) {
    console.error('Error creating bulk middle categories:', error);
    throw error;
  }
};

export const updateMiddleCategory = async (middleCategoryId, middleCategoryData) => {
  try {
    const response = await api.put(`/api/middle-categories/${middleCategoryId}`, middleCategoryData);
    return response.data;
  } catch (error) {
    console.error('Error updating middle category:', error);
    throw error;
  }
};

export const deleteMiddleCategory = async (middleCategoryId) => {
  try {
    const response = await api.delete(`/api/middle-categories/${middleCategoryId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting middle category:', error);
    throw error;
  }
};

// Helper function to clean up empty parameters
const cleanParams = (params) => {
  const cleaned = {};
  Object.keys(params || {}).forEach(key => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      cleaned[key] = value;
    }
  });
  return cleaned;
}; 